import { render, staticRenderFns } from "./InspectionItemsGroupedByTemplate.vue?vue&type=template&id=bc4bc19e&"
import script from "./InspectionItemsGroupedByTemplate.vue?vue&type=script&lang=js&"
export * from "./InspectionItemsGroupedByTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InspectionItemsGroupedByTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports